import { Spinner } from "~/components/spinner";

export function PendingComponent() {
  return (
    <div className="flex flex-1 items-center justify-center">
      <Spinner className="size-24 text-black" />
    </div>
  );
}
